import { ruleDefinitionDefaults } from './TagRulesCommon'
import TagProductsByStatus from './TagProductsByStatus';
import TagProductsByVendor from './TagProductsByVendor';
import TagProductsOnCreation from './TagProductsOnCreation';
import TagProductsByType from './TagProductsByType';
import TagProductsOnSale from './TagProductsOnSale';
import TagProductsByVariantOption from './TagProductsByVariantOption';
import TagOrdersByLocation from './TagOrdersByLocation';
import TagOrdersByVendor from './TagOrdersByVendor';
import TagNewProducts from './TagNewProducts';
import TagProductsByKeywords from './TagProductsByKeywords';
import TagCustomersByPurchasedProducts from './TagCustomersByPurchasedProducts';
import TagProductsWhenTagExists from './TagProductsWhenTagExists';
import TagProductsWhenMultipleTagsExist from './TagProductsWhenMultipleTagsExist';
import UpdateProductMetafieldFromDescriptionFieldPattern from './UpdateProductMetafieldFromDescriptionFieldPattern';
import UpdateProductMetafieldFromTagGroup from './UpdateProductMetafieldFromTagGroup';
import UpdateMultipleProductMetafieldsFromTagGroup from './UpdateMultipleProductMetafieldsFromTagGroup';
import UpdateProductVariantMetafieldFromVariantOptionMapping from './UpdateProductVariantMetafieldFromVariantOptionMapping';
import UpdateProductVariantMetafieldFromVariantOption from './UpdateProductVariantMetafieldFromVariantOption';
import UpdateProductMetafieldFromVariantOption from './UpdateProductMetafieldFromVariantOption';
import UpdateProductMetafieldFromTagMapping from './UpdateProductMetafieldFromTagMapping';

const ruleDefinitions = [
    TagProductsByStatus,
    TagProductsByVendor,
    TagProductsOnCreation,
    TagProductsByType,
    TagProductsOnSale,
    TagProductsByVariantOption,
    TagOrdersByLocation,
    TagOrdersByVendor,
    TagNewProducts,
    TagProductsByKeywords,
    TagCustomersByPurchasedProducts,
    TagProductsWhenTagExists,
    TagProductsWhenMultipleTagsExist,
    UpdateProductMetafieldFromDescriptionFieldPattern,
    UpdateProductMetafieldFromTagGroup,
    UpdateMultipleProductMetafieldsFromTagGroup,
    UpdateProductVariantMetafieldFromVariantOptionMapping,
    UpdateProductVariantMetafieldFromVariantOption,
    UpdateProductMetafieldFromVariantOption,
    UpdateProductMetafieldFromTagMapping,

    {
        ...ruleDefinitionDefaults,
        ruleType: "AutoTagProductByAge",
        title: "Auto Tag Products By Age",
        description: "Auto-tag products based on their date of creation. For example, tag products that are less than 3 month old as \"new\".",
        legacy: false,
        inProgress: true,
        tags: ["Products", "Tags"],
        getDefaultRuleState: () => {
            return {}
        }
    },
];

export const getRuleDefinitionByType = function (ruleType) {
    var existing = ruleDefinitions.filter(_ => _.ruleType === ruleType);

    if (existing.length > 0) {
        return existing[0];
    }

    return null;
};

export const RuleDefinitions = ruleDefinitions;